import { Nav, Container, SubNav , ProfileDrower } from "components"
import ContextContainer from "context/ContextContainer"

export const BaseLayout = () => {
    return (
        <div className='w-full  flex justify-end bg-hoory-125'>
            <ContextContainer>
                <>
                    <Nav />
                    <SubNav />
                    <Container />
                </>
            </ContextContainer>
        </div>
    )
}